<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">{{modalHeader}}</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
    </div>
    <div class="ttmodal__body">
        <div class="input-container">
            <span class="label">Job Site</span>
            <span class="label">{{jobsiteName}}</span>
        </div>
        <div class="input-container" *ngIf="!showWorkshop">
            <span class="label">Repairer</span>
            <input type="text" [(ngModel)]="repairer" class="input-design" placeholder="Enter the repairer name" />
        </div>
        <div class="input-container margin-bottom-16" *ngIf="showWorkshop">
            <span class="label">Location</span>
            <input type="text" [(ngModel)]="workshop" class="input-design" placeholder="Enter the workshop name" />
        </div>
    </div>
    <div class="ttmodal__footer">
        <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" [class.loading]="savingChanges" (click)="saveChanges()"><span class="button__text">Save</span></a>
    </div>
</div>